import { render } from "./TextArea.vue?vue&type=template&id=03576c0b"
import script from "./TextArea.vue?vue&type=script&lang=js"
export * from "./TextArea.vue?vue&type=script&lang=js"

import "./TextArea.vue?vue&type=style&index=0&id=03576c0b&lang=css"

import exportComponent from "/Users/tatana/Documents/Chext/dev/neatify_frnt-bck/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__